import { render } from "./CampaignNodata.vue?vue&type=template&id=5755c644"
const script = {}

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__